<template>
  <div class="h-100">
    <div class="container-wrapper">
      <h2 class="title">Акції</h2>
    </div>
    <div class="horizontal-scroll">
      <div class="fit-boxes">
        <div class="single-promotion" v-for="(item,index) in list" :key="index">
          <PromotionCard 
            :promotion="item"
            :index="index+1"
            @finish="onPromotionEditFinish"
            @delete="showDeleteUI"
            />
        </div>

        <PromotionCard :promotion="new_promotion" :index="-1" v-if="adding_new_promotion"/>

        <button class="add-discount" v-if="list.length < 30"  @click="showAddUI">+ Додати акцію</button>
      </div>
    </div>

    <DangerConfirmModal @confirm="deletePromotion" @cancel="action_delete.active = false" v-if="action_delete.active">
      Ви впевнені що хочете видалити цю акцію?
    </DangerConfirmModal>
  </div>
</template>

<script>
import PromotionCard from "@/components/promotions/PromotionCard.vue";
import PromotionsAPI from '@/api/promotions'

import moment from 'moment'

export default {
  data() {
    return {
      list: [],
      new_promotion: {
        type: 'discount',
        menu_id: null,
        period_start: null,
        period_end: null,
        modes: {
          inside: false,
          preorder: false,
          delivery: false
        }
      },
      adding_new_promotion: false,
      action_delete: {
        active: false,
        promotion_id: null
      }
    };
  },
  methods: {
    fetchData() {
      PromotionsAPI.getList().then(data => {
        this.list = data.list;
      }).catch(error => {
        alert(error);
      });
    },
    onPromotionEditFinish(promotion) {
      PromotionsAPI.update(
        promotion._id,
        promotion
      ).then(data => {

      }).catch(error => {
        alert(error);
      });
    },
    showDeleteUI(id) {
      this.action_delete.active = true;
      this.action_delete.promotion_id = id;
    },
    deletePromotion() {
      this.action_delete.active = false;
      PromotionsAPI.remove(this.action_delete.promotion_id).then(data => {
        this.fetchData();
      }).catch(error => {
        alert(error);
      }); 
    },
    showAddUI() {
      // this.adding_new_promotion = true;
      // this.new_promotion = {
      //   type: 'discount',
      //   menu_id: null,
      //   period_start: null,
      //   period_end: null,
      //   modes: {
      //     inside: false,
      //     preorder: false,
      //     delivery: false
      //   }
      // }

      PromotionsAPI.create({
        type: 'discount',
        menu_id: null,
        period_start: moment().startOf('month').toDate(),
        period_end: moment().endOf('month').toDate(),
        discount: 10,
        modes: {
          inside: false,
          preorder: false,
          delivery: false
        }
      }).then(data => {
        this.list.push(data.promotion);
      }).catch(error => {
        alert(error);
      });
    }
  },
  mounted() {
    this.$store.dispatch("menu/fetchMenus");
    this.fetchData();
  },
  components: {
    PromotionCard,
   }
};
</script>

<style scoped>
.fit-boxes {
  width: fit-content;
  height: 75vh;
  display: flex;
  flex-flow: column nowrap;
  overflow: auto;
}

.add-discount {
  background: transparent;
  border: 1px solid #ededed;
  border-radius: 1.5vh;
  font-size: 3vh;
  margin-top: 3.3vh;
  padding: 2vh 0;
  text-align: center;
  transition: 0.3s;
  cursor: pointer;
  color: #ededed;
  width: 54vh;
}

.add-discount:hover {
  background: #ededed;
  color: #1d1d1d;
}

.labels {
  display: flex;
}

.label,
.label-active,
.label-archive {
  background: #ededed;
  margin-top: 1.1vh;
  color: #1d1d1d;
  border-radius: 0.8vh;
  font-size: 1.7vh;
  padding: 0.5vh 0;
  min-width: 12vh;
  text-align: center;
  font-weight: bold;
}

.label-active {
  margin-left: auto;
  font-weight: normal !important;
  background: #129b81 !important;
  color: #ededed !important;
}

.label-archive {
  margin-left: auto;

  background: #a4a3a1 !important;
}

h4,
p {
  font-size: 2.2vh;
}

h4 {
  color: #a4a3a1;
  display: flex;
  line-height: 1.5;
  align-items: baseline;
  margin-bottom: 0;
}

p {
  margin: 0;
  padding-left: 1.1vh;
  color: #ededed;
}

.h-100 {
  height: 100vh !important;
}
</style>